export const PopularFAs = [
  {
    id: 148,
    name: "Telesales / Telemarketing"
  },
  {
    id: 51,
    name: "Operations Executive"
  },
  {
    id: 20,
    name: "Back Office Executive"
  },
  {
    id: 53,
    name: "Sales / Business Development"
  },
  {
    id: 31,
    name: "Delivery Boy"
  },
  {
    id: 37,
    name: "Customer Care"
  },
  {
    id: 34,
    name: "Human Resource (HR)"
  },
  {
    id: 36,
    name: "Admin Executive"
  },
  {
    id: 33,
    name: "Accountant"
  }
];
